import React, { useState } from 'react';
import { CreateScenarioModal } from './CreateScenarioModal';
import { Link } from 'react-router-dom';

// Comment out default scenarios for now

export function DirectDisplayOptimizer() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [scenarios, setScenarios] = useState(() => {
    const saved = localStorage.getItem('scenarios');
    return saved ? JSON.parse(saved) : [];
  });

  const handleAddScenario = (newScenario) => {
    const savedScenarios = JSON.parse(localStorage.getItem('scenarios') || '[]');
    const updatedSavedScenarios = [newScenario, ...savedScenarios];
    localStorage.setItem('scenarios', JSON.stringify(updatedSavedScenarios));
    
    setScenarios(updatedSavedScenarios);
  };

  const handleDeleteScenario = (scenarioId) => {
    const savedScenarios = JSON.parse(localStorage.getItem('scenarios') || '[]');
    const updatedScenarios = savedScenarios.filter(scenario => scenario.id !== scenarioId);
    localStorage.setItem('scenarios', JSON.stringify(updatedScenarios));
    
    setScenarios(updatedScenarios);  // Update state with filtered scenarios
    localStorage.removeItem(`scenario_options_${scenarioId}`);
  };

  return (
    <main className="main-content">
      <h1 className="page-title">Direct Display Optimizer</h1>
      
      <button 
        className="create-scenario-button"
        onClick={() => setIsModalOpen(true)}
      >
        Create New Scenario
      </button>

      <div className="scenarios-section">
        <h2 className="section-title">Recent Scenarios</h2>
        {scenarios.length === 0 ? (
          <div className="no-scenarios">
            Please create a new scenario
          </div>
        ) : (
          scenarios.map((scenario) => (
            <Link 
              to={`/partners/display/optimize/scenario/${scenario.id}`}
              key={scenario.id}
              className="scenario-card"
              state={{ scenarioData: scenario }}
            >
              <div className="scenario-content">
                <h3 className="scenario-name">{scenario.name}</h3>
                <div className="scenario-details">
                  <span className="detail-item">
                    <span className="detail-label">KPI:</span> {scenario.kpi}
                  </span>
                  <span className="detail-item">
                    <span className="detail-label">Budget:</span> ${scenario.budget.toLocaleString()}
                  </span>
                  <span className="detail-item">
                    <span className="detail-label">Status:</span> {scenario.status}
                  </span>
                  {/* <span className="detail-item">
                    <span className="detail-label">Attribution Model:</span>
                    {scenario.attributionModel}
                  </span> */}
                  <span className="detail-item">
                    <span className="detail-label">Options:</span>
                    {scenario.optionsCount || 0}
                  </span>
                </div>
              </div>
              {/* Only show delete button for non-default scenarios */}
              {!scenario.id.toString().startsWith('default-') && (
                <button 
                  className="delete-scenario-button"
                  onClick={(e) => {
                    e.preventDefault(); // Prevent navigation
                    e.stopPropagation(); // Prevent event bubbling
                    handleDeleteScenario(scenario.id);
                  }}
                >
                  Remove
                </button>
              )}
            </Link>
          ))
        )}
      </div>

      <CreateScenarioModal 
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onAdd={handleAddScenario}
      />
    </main>
  );
} 